import { FormattedMessage } from "react-intl";
import RefreshButton from "components/financials/modern/RefreshButton";
import { getPlatformVerticalTitle } from "components/financials/modern/utils/platformVertical";
import { SheetDescription, SheetHeader, SheetTitle } from "components/ui/Sheet";
import type { IPlatformVertical } from "types/graphqlTypes";

interface TemplateSheetHeaderProps {
  isCreatingTemplate: boolean;
  isDefiningTemplate: boolean;
  isEditingTemplate: boolean;
  vertical: IPlatformVertical;
  loading: boolean;
  onRefresh: () => void;
}

export function TemplateSheetHeader({
  isCreatingTemplate,
  isDefiningTemplate,
  isEditingTemplate,
  vertical,
  loading,
  onRefresh,
}: TemplateSheetHeaderProps) {
  if (isDefiningTemplate) {
    return (
      <SheetHeader className="space-y-1 text-left">
        <SheetTitle className="text-3xl font-black text-slate-800 dark:text-white">
          {isEditingTemplate && <FormattedMessage defaultMessage="Editar Template" id="IK2tas" />}
          {isCreatingTemplate && <FormattedMessage defaultMessage="Novo Template" id="BqxNlO" />}
        </SheetTitle>
      </SheetHeader>
    );
  }

  return (
    <SheetHeader className="space-y-1 text-left">
      <div className="flex items-center gap-x-4">
        <SheetTitle className="pr-12 text-2xl font-black text-slate-800 dark:text-white sm:pr-0 sm:text-3xl">
          <FormattedMessage
            defaultMessage="Templates para {vertical}"
            id="c9mgeD"
            values={{
              vertical: getPlatformVerticalTitle(vertical),
            }}
          />
        </SheetTitle>

        <RefreshButton loading={loading} className="hidden sm:flex" onClick={() => onRefresh()} />
      </div>

      <SheetDescription>
        <FormattedMessage
          defaultMessage="Clique no botão abaixo para criar um template do zero com os indicadores que quiser. Ou favorite os templates do Fundamentei e dos usuários do site. Você também pode definir como padrão ou copiar para os seus templates para editar os indicadores."
          id="udIpeB"
        />
      </SheetDescription>
    </SheetHeader>
  );
}
